import React from 'react';
import { sessionLogger } from '@chegg-ui/utils';
import { getAboutLinks, getLegalLinks, getNetworkLinks, getProductLinks, getServiceLinks } from '../shared';
import { FooterFlexBox, FooterFlexCell, FooterLinkTitle, FooterLinkList, FooterLinkListItem, SmallerLink, DoubleWidthFooterFlexCell, TwoColumnLinkList } from '../styles';

var DesktopFooterLinks = function DesktopFooterLinks(_ref) {
  var envUrl = _ref.envUrl,
      pageTrackId = _ref.pageTrackId;

  // TODO infra: memoize links? https://chegg.atlassian.net/browse/CUI-368
  var sLog = function sLog(data) {
    return sessionLogger.event(envUrl, pageTrackId, data);
  };

  return /*#__PURE__*/React.createElement(FooterFlexBox, null, /*#__PURE__*/React.createElement(FooterFlexCell, null, /*#__PURE__*/React.createElement(FooterLinkTitle, null, "COMPANY"), /*#__PURE__*/React.createElement(FooterLinkList, null, getAboutLinks(envUrl).map(function (linkDetails) {
    return /*#__PURE__*/React.createElement(FooterLinkListItem, {
      key: linkDetails.href
    }, /*#__PURE__*/React.createElement(SmallerLink, {
      href: linkDetails.href,
      "data-test": "footer-".concat(linkDetails.loggingKey),
      rel: linkDetails.nofollow ? 'nofollow' : undefined,
      onClick: function onClick() {
        return sLog({
          footer_cta_click: linkDetails.loggingKey
        });
      }
    }, linkDetails.text));
  }))), /*#__PURE__*/React.createElement(FooterFlexCell, null, /*#__PURE__*/React.createElement(FooterLinkTitle, null, "LEGAL & POLICIES"), /*#__PURE__*/React.createElement(FooterLinkList, null, getLegalLinks(envUrl).map(function (linkDetails) {
    return /*#__PURE__*/React.createElement(FooterLinkListItem, {
      key: linkDetails.href
    }, /*#__PURE__*/React.createElement(SmallerLink, {
      className: linkDetails.className,
      id: linkDetails.id,
      href: linkDetails.href,
      "data-test": "footer-".concat(linkDetails.loggingKey),
      rel: linkDetails.nofollow ? 'nofollow' : undefined,
      onClick: function onClick() {
        return sLog({
          footer_cta_click: linkDetails.loggingKey
        });
      }
    }, linkDetails.text));
  }))), /*#__PURE__*/React.createElement(DoubleWidthFooterFlexCell, null, /*#__PURE__*/React.createElement(FooterLinkTitle, null, "CHEGG PRODUCTS AND SERVICES"), /*#__PURE__*/React.createElement(TwoColumnLinkList, null, getProductLinks(envUrl).map(function (linkDetails) {
    return /*#__PURE__*/React.createElement(FooterLinkListItem, {
      key: linkDetails.href
    }, /*#__PURE__*/React.createElement(SmallerLink, {
      href: linkDetails.href,
      "data-test": "footer-".concat(linkDetails.loggingKey),
      rel: // as of now we don't have any links in this section with nofollow, so we can't really cover
      linkDetails.nofollow ?
      /* istanbul ignore next */
      'nofollow' : undefined,
      onClick: function onClick() {
        return sLog({
          footer_cta_click: linkDetails.loggingKey
        });
      }
    }, linkDetails.text));
  }))), /*#__PURE__*/React.createElement(FooterFlexCell, null, /*#__PURE__*/React.createElement(FooterLinkTitle, null, "CHEGG NETWORK"), /*#__PURE__*/React.createElement(FooterLinkList, null, getNetworkLinks().map(function (linkDetails) {
    return /*#__PURE__*/React.createElement(FooterLinkListItem, {
      key: linkDetails.href
    }, /*#__PURE__*/React.createElement(SmallerLink, {
      href: linkDetails.href,
      "data-test": "footer-".concat(linkDetails.loggingKey),
      rel: // as of now we don't have any links in this section with nofollow, so we can't really cover
      linkDetails.nofollow ?
      /* istanbul ignore next */
      'nofollow' : undefined,
      onClick: function onClick() {
        return sLog({
          footer_cta_click: linkDetails.loggingKey
        });
      }
    }, linkDetails.text));
  }))), /*#__PURE__*/React.createElement(FooterFlexCell, null, /*#__PURE__*/React.createElement(FooterLinkTitle, null, "CUSTOMER SERVICE"), /*#__PURE__*/React.createElement(FooterLinkList, null, getServiceLinks(envUrl).map(function (linkDetails) {
    return /*#__PURE__*/React.createElement(FooterLinkListItem, {
      key: linkDetails.href
    }, /*#__PURE__*/React.createElement(SmallerLink, {
      href: linkDetails.href,
      "data-test": "footer-".concat(linkDetails.loggingKey),
      rel: linkDetails.nofollow ? 'nofollow' : undefined,
      onClick: function onClick() {
        return sLog({
          footer_cta_click: linkDetails.loggingKey
        });
      }
    }, linkDetails.text));
  }))));
};

DesktopFooterLinks.displayName = 'DesktopFooterLinks';
export default DesktopFooterLinks;